import React, { Fragment } from 'react';
import { useAIAnswerContext } from '../ai-answer-context';
import { ReadingAidsMenuButton } from './reading-aids-menu-button';
import { ReadingAidsOptionsWrapper } from './styled';
export var ReadingAidsOptions = function ReadingAidsOptions() {
  var _useAIAnswerContext = useAIAnswerContext(),
    readingAidsOptions = _useAIAnswerContext.readingAidsOptions;
  var _ref = readingAidsOptions || {},
    menuOptions = _ref.menuOptions;
  var showMenuButton = !!(menuOptions !== null && menuOptions !== void 0 && menuOptions.length);
  if (!showMenuButton) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(ReadingAidsOptionsWrapper, null, showMenuButton && /*#__PURE__*/React.createElement(ReadingAidsMenuButton, null)));
};